export default "__VITE_ASSET__57d064c8__"